import { render, staticRenderFns } from "./PfPView.vue?vue&type=template&id=fa7c5ad2&"
import script from "./PfPView.vue?vue&type=script&lang=js&"
export * from "./PfPView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports